
import Vue from "vue";
import { mapState } from "vuex";
import moment from "moment";
import { download } from "@/utils";
import { dispatch, Captcha } from "@/store";

export default Vue.extend({
  data() {
    return {
      moment,
      sn: "",
      captcha: null as Captcha | null,
      captchaInstance: null as any,
      loading: false,
      name: "",
      whereVisible: false,
      alertVisible: false,
      result: null
    };
  },
  computed: {
    ...mapState({ user: "user" }),
    ...mapState("app", {
      isCN: "isCN",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      oss: "oss",
      url: "url"
    }),
    products(): any {
      return {
        cyberboard: {
          title: this.$t("cyberboard.name"),
          name: "CYBERBOARD",
          where: this.$t("verify.where.cyberboard"),
          bg: this.oss.verify_cyberboard_bg,
          sn: this.oss.verify_cyberboard_sn,
          userManual: ""
        },
        cyberblade: {
          title: this.$t("cyberblade.name"),
          name: "CYBERBLADE",
          where: "",
          bg: this.oss.verify_cyberblade_bg,
          sn: "",
          userManual: ""
        },
        "am-hatsu": {
          title: this.$t("AMHatsu.name"),
          name: "AM HATSU",
          where: this.$t("verify.where.AMHatsu"),
          bg: this.oss.verify_am_hatsu_bg,
          sn: this.oss.verify_am_hatsu_sn,
          userManual: ""
        },
        "am-afa": {
          title: this.$t("AMAfa.name"),
          name: "AM AFA",
          where: "",
          bg: this.oss.verify_am_afa_bg,
          sn: this.oss.verify_am_afa_sn,
          userManual: ""
        },
        "am-65-less": {
          title: this.$t("AM65Less.name"),
          name: "AM 65 Less",
          where: "",
          bg: this.oss.verify_am_65_less_bg,
          sn: this.oss.verify_am_65_less_sn,
          userManual: ""
        },
        cybermat: {
          title: this.$t("cybermat.name"),
          name: "CYBERMAT",
          where: this.$t("verify.where.cybermat"),
          bg: this.oss.verify_cybermat_bg,
          sn: this.oss.verify_cybermat_sn,
          userManual: ""
        },
        "black-diamond-75": {
          title: "BLACK DIAMOND 75",
          name: "BLACK DIAMOND 75",
          where: this.$t("verify.where.cyberboard"),
          bg: this.oss.black_diamond_75_bg,
          sn: this.oss.black_diamond_75_sn,
          userManual: ""
        }
      };
    },
    product(): any {
      if (this.name && this.products[this.name]) {
        return this.products[this.name];
      }
      return this.products.cyberboard;
    }
  },
  methods: {
    verifyInit() {
      const mobileBreakpoint = 768;
      const baseWidth = 375;
      const sceneId = "y349l147";
      const pageWidth = window.innerWidth;
      const isMobileDevice = pageWidth <= mobileBreakpoint;
      const remScale = isMobileDevice ? Math.min(pageWidth / baseWidth, 1) : 1;
      const controlHeight = isMobileDevice ? 18 : 52;
      const captchaElement = document.getElementById("nc");

      if (captchaElement) {
        captchaElement.innerHTML = "";
      }
      this.captcha = null;

      const fallbackWidth = isMobileDevice
        ? Math.max(Math.min(pageWidth - 48, 300), 260)
        : 500;
      const slideWidth = captchaElement
        ? Math.min(captchaElement.clientWidth || fallbackWidth, 600)
        : fallbackWidth;

      try {
        (window as any).initAliyunCaptcha({
          SceneId: sceneId,
          mode: "embed",
          element: "#nc",
          language: this.isCN ? "cn" : "en",
          slideStyle: {
            width: slideWidth,
            height: controlHeight
          },
          rem: remScale,
          success: (captchaVerifyParam: any) => {
            this.captcha = {
              captchav_verify_param: captchaVerifyParam,
              scene_id: sceneId
            };
          },
          fail: () => {
            this.captcha = null;
            this.verifyInit();
          },
          getInstance: (instance: any) => {
            this.captchaInstance = instance;
          }
        });
      } catch (error) {
        this.captchaInstance = null;
        console.error("验证码初始化失败:", error);
        this.$message.info("" + this.$t("cant access captcha info"));
      }
    },
    submitVerifyCheck(captcha: Captcha) {
      this.loading = true;
      this.result = null;
      this.captcha = null;
      dispatch
        .verifyCheck({
          captcha,
          sn_code: this.sn
        })
        .then(data => {
          // if (data.times > 1) {
          //   this.alertVisible = true;
          // }
          this.loading = false;
          this.result = data;
          this.$nextTick(() => this.verifyInit());
        })
        .catch(() => {
          this.loading = false;
          this.result = null;
          this.$nextTick(() => this.verifyInit());
        });
    },
    onDownload() {
      download(this.product.userManual);
    },
    onSNInput() {
      this.sn = this.sn.trim().substring(0, 36);
      this.result = null;
      if (this.captcha) {
        this.$nextTick(() => this.verifyInit());
      }
    },
    onSearch() {
      if (!this.sn || this.loading) {
        return;
      }
      if (!this.user.isSignIn) {
        dispatch.userSignIn().then(() => {
          this.$nextTick(() => this.verifyInit());
        });
        return;
      }

      const captcha = this.captcha;
      if (!captcha) {
        this.$message.info(
          this.isCN
            ? "请先完成滑动验证后再查询"
            : "Please complete the slider verification before searching"
        );
        return;
      }

      this.submitVerifyCheck(captcha);
    }
  },
  watch: {
    ["$route.params.name"](name) {
      if (name) {
        this.name = name;
        this.result = null;
        this.$nextTick(() => this.verifyInit());
      }
    }
  },
  mounted() {
    this.name = this.$route.params.name || "cyberboard";
    if (!this.user.isSignIn) {
      dispatch.userSignIn().then(() => {
        if (!this.product) {
          this.$router.push(this.$paths.home);
          return;
        }
        this.$nextTick(() => {
          this.verifyInit();
        });
      });
    } else {
      if (!this.product) {
        this.$router.push(this.$paths.home);
      } else {
        this.$nextTick(() => {
          this.verifyInit();
        });
      }
    }
  }
});
